"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DdfPeriodController = (function () {
    function DdfPeriodController() {
    }
    DdfPeriodController.calculateTotalPeriod = function (plan) {
        var flatPlacements = DdfPeriodController.flattenMediumGroups(plan);
        var collectedPeriods = DdfPeriodController.collectPeriods(flatPlacements).sort();
        var totalPeriod = [_.first(collectedPeriods), _.last(collectedPeriods)];
        return [{ from: totalPeriod[0], to: totalPeriod[1] }];
    };
    DdfPeriodController.flattenMediumGroups = function (plan) {
        var flatPlacements = [];
        plan.mediumGroups.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup.forEach(function (placement) {
                flatPlacements.push(placement);
            });
        });
        return flatPlacements;
    };
    DdfPeriodController.collectPeriods = function (placements) {
        var periods = [];
        placements.forEach(function (placement) {
            var dates = _.get(placement, "dates");
            dates.forEach(function (date) {
                var from = date.from;
                var to = date.to;
                periods.push(from);
                periods.push(to);
            });
        });
        return periods;
    };
    return DdfPeriodController;
}());
exports.DdfPeriodController = DdfPeriodController;
//# sourceMappingURL=DdfPeriodController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/DdfPeriodController.js
// module id = 50
// module chunks = 0